import {
    Form,
    useTranslate,
    NumberInput,
    useRecordContext,
    useNotify,
    usePermissions,
} from "react-admin";
import { Button, Box } from "@mui/material";
import { ConfirmationDialog } from "shared/src/components/dialogs/ConfirmationDialog";
import { RaSelectInput } from "shared/src/components/inputs/Ra/RaSelectInput";

export const PrintLabels = (props) => {
    const translate = useTranslate();
    const record = useRecordContext();
    const notify = useNotify();
    const { permissions } = usePermissions();
    const printers = permissions.config.get("printers") || [];

    const print = (data) => {
        const quantity = Number(data.quantity);
        const configuredPrinterIds = printers.map((printer) => printer.id);
        if (!Number.isInteger(quantity) || quantity < 1 || quantity > 10 || !configuredPrinterIds.includes(data.ip)) {
            notify("equip.labelPrintJobNotPlaced", {
                type: "error",
            });
            return;
        }

        const route = props.arrivalData
            ? props.arrivalData._links.label_pdf
            : record._links.label_pdf;

        fetch(route, {
            method: "POST",
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify({ ...data, quantity }),
        })
            .then((response) => {
                if (response.status < 200 || response.status >= 400) {
                    throw new Error(response.statusText);
                }
                notify("equip.labelPrintJobPlaced", {
                    type: "success",
                });
                props.setPrintLabels(false);
            })
            .catch(() => {
                notify("equip.labelPrintJobNotPlaced", {
                    type: "error",
                });
            });
    };

    return (
        <ConfirmationDialog
            label={translate("equip.printLabels")}
            confirmButton={false}
            cancelButton={false}
            content={
                <Form
                    onSubmit={print}
                    record={{ quantity: 1, type: "barcode" }}
                >
                    <NumberInput
                        fullWidth
                        label="equip.labelQuantity"
                        title={translate("equip.labelQuantity")}
                        source="quantity"
                        min={1}
                        max={10}
                    />
                    <RaSelectInput
                        fullWidth
                        label="equip.printer"
                        required
                        source="ip"
                        defaultValue={printers[0]?.id || ''}
                        choices={printers}
                    />
                    <RaSelectInput
                        fullWidth
                        required
                        source="type"
                        choices={[
                            { id: "barcode", name: "Barcode" },
                            { id: "qr", name: "QR" },
                            { id: "landingpage", name: "Landingpage QR" },
                        ]}
                    />
                    <Box
                        sx={{
                            display: "flex",
                            justifyContent: "space-between"
                        }}>
                        <Button
                            variant="contained"
                            type="submit"
                            title={translate("equip.print")}
                            aria-label={translate("equip.print")}
                        >
                            {translate("equip.print")}
                        </Button>
                        <Button
                            onClick={() => {
                                props.setPrintLabels(false);
                            }}
                            title={translate("equip.close")}
                            aria-label={translate("equip.close")}
                        >
                            {translate("equip.close")}
                        </Button>
                    </Box>
                </Form>
            }
        />
    );
};
